__turbopack_context__.v({
  "button": "Vr3lfq_button",
  "buttonWrap": "Vr3lfq_buttonWrap",
  "container": "Vr3lfq_container",
  "sectionHeading": "Vr3lfq_sectionHeading",
});
